function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { json2excel } from 'js2excel'; // import './AVIChartCommon.scss'; this file is missing now

import './AVITableTile.scss';
export var AVITableTile = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AVITableTile, _Component);

  function AVITableTile(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.downloadTable = _this.downloadTable.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = AVITableTile.prototype;

  _proto.pad = function pad(s, n) {
    s = '' + s;

    while (s.length < n) {
      s = '0' + s;
    }

    return s;
  };

  _proto.getTimestamp = function getTimestamp() {
    var d = new Date();
    var str = '' + d.getFullYear();
    str += this.pad(d.getMonth() + 1, 2);
    str += this.pad(d.getDay(), 2);
    str += this.pad(d.getHours(), 2);
    str += this.pad(d.getMinutes(), 2);
    return str;
  };

  _proto.downloadTable = function downloadTable(fname, useTimeStamp) {
    if (useTimeStamp === void 0) {
      useTimeStamp = true;
    }

    var _this$props = this.props,
        title = _this$props.title,
        getTableData = _this$props.getTableData;
    var ltitle = (fname ? fname + '-' : '') + (useTimeStamp ? this.getTimestamp() : '');

    if (!fname && !useTimeStamp) {
      ltitle = this.getTimestamp();
    }

    try {
      var data = getTableData(); // NB! Variable carrying data must be named 'data' in object below

      json2excel({
        data: data,
        name: ltitle,
        formateDate: 'yyyy/mm/dd'
      });
    } catch (e) {
      console.error('export error');
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        title = _this$props2.title,
        description = _this$props2.description,
        showTools = _this$props2.showTools,
        ToolsComponent = _this$props2.toolsComponent,
        getChart = _this$props2.getChart;
    return /*#__PURE__*/React.createElement("div", {
      className: "avi-table-tile table-tile"
    }, title && /*#__PURE__*/React.createElement("h4", null, title), description && /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement("div", {
      className: "avi-table-container table-container"
    }, children), showTools && (ToolsComponent ? /*#__PURE__*/React.createElement(ToolsComponent, {
      getChart: getChart,
      onDownloadXLS: this.downloadTable
    }) : /*#__PURE__*/React.createElement("div", {
      className: "avi-clear-both clear-both no-print"
    }, /*#__PURE__*/React.createElement("a", {
      className: "avi-chart-action-link chart-action-link",
      onClick: this.downloadTable
    }, "Last ned tabell (MS Excel)"))));
  };

  return AVITableTile;
}(Component);

_defineProperty(AVITableTile, "defaultProps", {
  width: 4
});

AVITableTile.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  description: PropTypes.string,
  getTableData: PropTypes.func.isRequired,

  /** If true, tools to reset or download chart as SVG or PNG is shown. */
  showTools: PropTypes.bool,

  /**
   * If set, this component is rendered instead of standard tools.
   *
   * Callbacks for performing the default actions are provided as props.
   *
   * @param onDownloadXLS Download table as XLS
   */
  toolsComponent: PropTypes.any
} : {};